import * as Tools from "../../../../helpers/Tools";

const useRoomTime = () => {
    const TIME_FORMAT = "LT";

    const getRoomTimes = (
        appointmentDetails,
        ambulatoryVideoVisitEnabled,
        isSDCVisit,
        SDCVisitEnabledMinutesBeforeStart,
        SDCVisitEnabledMinutesAfterStart,
        videoVisitEnabledMinutesBeforeStart,
        videoVisitEnabledMinutesAfterStart,
    ) => {
        const videoVisit = appointmentDetails;
        const visitsEnabled = ambulatoryVideoVisitEnabled;
        let openRoomTime = '';
        let closedRoomTime = '';
        let visitDateTimeBefore = '';
        let visitDateTimeAfter = '';

        if (visitsEnabled && videoVisit && videoVisit?.appointmentDateTime) {
            const minutesBefore = isSDCVisit ? SDCVisitEnabledMinutesBeforeStart : videoVisitEnabledMinutesBeforeStart;
            const minutesAfter = isSDCVisit ? SDCVisitEnabledMinutesAfterStart : videoVisitEnabledMinutesAfterStart;

            visitDateTimeBefore = Tools.subtractMinutesFromDate(videoVisit.appointmentDateTime, minutesBefore);
            visitDateTimeAfter = Tools.addMinutesToDate(videoVisit.appointmentDateTime, minutesAfter);

            // get room open time
            openRoomTime = (Tools.formatCentralDate(visitDateTimeBefore, TIME_FORMAT));
            closedRoomTime = (Tools.formatCentralDate(visitDateTimeAfter, TIME_FORMAT));
        } 

        return {
            openRoomTime,
            closedRoomTime,
            visitDateTimeBefore,
            visitDateTimeAfter
        }
    }

    return {
        getRoomTimes,
    };
};

export default useRoomTime;